import { render } from "./404.vue?vue&type=template&id=2bc41f4a&scoped=true"
import script from "./404.vue?vue&type=script&lang=js"
export * from "./404.vue?vue&type=script&lang=js"

import "./404.vue?vue&type=style&index=0&id=2bc41f4a&scoped=true&lang=css"

import exportComponent from "E:\\newwww\\shared_space\\shared_agency\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2bc41f4a"]])

export default __exports__